import { versionPropTypes } from '@gef-ui/version-info-core/constants';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
const VersionItem = ({ name, version })=>/*#__PURE__*/ React.createElement(Typography, {
        key: name,
        sx: {
            color: 'text.secondary'
        }
    }, `${name}: ${version}`, /*#__PURE__*/ React.createElement("br", null));
VersionItem.propTypes = {
    name: PropTypes.string,
    version: PropTypes.string
};
const VersionDisplay = ({ fe = [], be = [], versionElementId })=>{
    const simpleView = useMemo(()=>fe.length === 1 && be.length === 1, [
        be,
        fe
    ]);
    return simpleView ? /*#__PURE__*/ React.createElement(Grid, {
        id: versionElementId
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            color: 'text.secondary'
        }
    }, "FE: ", fe[0].version.trim(), " x BE: ", be[0].version)) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        columnSpacing: 2,
        id: `${versionElementId}_FE`
    }, fe.map(VersionItem)), /*#__PURE__*/ React.createElement(Grid, {
        columnSpacing: 2,
        id: `${versionElementId}_BE`
    }, be.map(VersionItem)));
};
VersionDisplay.propTypes = {
    /**
	 * Array of backend versions in the form of {name, version }objects
	 */ be: versionPropTypes,
    /**
	 * A frontend version
	 */ fe: versionPropTypes,
    versionElementId: PropTypes.string
};
export default VersionDisplay;
